/* eslint-disable no-useless-escape */
/* eslint-disable no-irregular-whitespace */
import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { useSendCustomSlackMessage } from 'utils/hooks/mutations/user-mutations';
import Link from 'next/link';
import Image from 'next/image';
import { LoadingButton } from '@mui/lab';
import styled from 'styled-components';
const validateEmail = (email: string) => {
  return email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};
export const SubscribeInputBlock = () => {
  const {
    mutate,
    isLoading
  } = useSendCustomSlackMessage();
  const [email, setValue] = useState('');
  const [successMessage, setSetSuccessMessage] = useState(null as null | string);
  const submitHandler = () => {
    // add email validation
    if (validateEmail(email)) {
      setValue('');
      mutate({
        message: `${email} subscribed to the newsletter.`
      }, {
        onSuccess: () => {
          setSetSuccessMessage('Successfully subscribed');
        },
        onError: () => {
          toast('Failed to subscribe.');
        }
      });
    } else {
      toast('Email is invalid');
    }
  };
  return <Box sx={{
    backgroundColor: '#F2F8FF',
    p: {
      xs: '36px',
      md: '96px 76px 96px 76px'
    }
  }} id="newsletter">
      <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      gap: '24px'
    }}>
        <Image src={`/assets/svg/Newsletter.svg`} alt="" width={34.41} height={29.3} />

        <Typography sx={{
        fontSize: '2rem',
        fontWeight: 700,
        textAlign: 'center'
      }}>
          Subscribe to our EV newsletter for dealers
        </Typography>
        <Typography sx={{
        color: '#44485A',
        textAlign: 'center'
      }}>
          Join 9,000+ other automotive professionals diving into EVs and streamlining their EV sales processes!
        </Typography>

        <Box sx={{
        display: 'flex',
        gap: '0.5rem',
        alignItems: 'center',
        flexDirection: {
          xs: 'column',
          md: 'row'
        }
      }}>
          {successMessage ? <>
              <Typography sx={{
            color: 'green',
            fontWeight: 600
          }}>{successMessage}</Typography>
            </> : <>
              <input style={{
            padding: '12px 20px 12px 20px',
            border: '1px solid #CCD0E2',
            fontFamily: 'Gilroy',
            minWidth: '325px',
            height: '48px'
          }} value={email} onChange={e => setValue(e?.target?.value)} name="email" type="email" placeholder="Your email" />
              <StyledLoadingBtn onClick={submitHandler} loading={isLoading} sx={{
            backgroundColor: '#3547C5',
            fontFamily: 'Gilroy',
            borderRadius: 0,
            textTransform: 'none',
            color: '#fff',
            height: '48px',
            p: '12px 40px 12px 40px'
          }}>
                Subscribe
              </StyledLoadingBtn>
            </>}
        </Box>

        <Typography sx={{
        color: '#44485A'
      }}>
          Follow Lectrium&lsquo;s latest news on 
          <Link href="https://www.linkedin.com/company/lectrium/" style={{
          color: '#3547C5',
          fontWeight: 600
        }} target="_blank">
            LinkedIn
          </Link>
        </Typography>
      </Box>
    </Box>;
};
const StyledLoadingBtn = styled(LoadingButton)`
  :hover {
    background-color: #4759cb;
  }
`;